/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KpiValue } from '../../models/kpi-value';

export interface GetProductionOrderKpis$Params {
  productionOrderId: number;
  workCenterId: string;
}

export function getProductionOrderKpis(http: HttpClient, rootUrl: string, params: GetProductionOrderKpis$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KpiValue>>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderKpis.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KpiValue>>;
    })
  );
}

getProductionOrderKpis.PATH = '/api/v1/ShiftReport/{workCenterId}/GetProductionOrderKpis/{productionOrderId}';
